import { css } from 'lit';

export const mobileStyles = css`

`;
